import React, { useEffect, useState } from 'react'
import { FiX } from 'react-icons/fi'
import ReactDragDrawer from 'react-drag-drawer'
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import {
  BsEnvelope,
  BsPerson,
  BsInfoCircle,
  BsQuestionCircle,
  BsBoxArrowRight,
  BsCash,
  BsFileEarmarkText,
  BsShieldLock,
  BsLightbulb,
  BsBoxArrowInRight,
  BsPersonPlus
} from 'react-icons/bs'
import LogoImage from '../../assets/images/new/app-icon.png'
import clsx from 'clsx'
import { SUBSCRIBER_PROVIDER_NAME } from '../../consts/common'
import Button from '../../components/button'
import GhostButton from '../../components/ghost-button'

const DrawerMenu = (props) => {
  const [showConfirmLogout, setShowConfirmLogout] = useState(false)

  useEffect(() => {
    if (!props.isOpened && showConfirmLogout) {
      setShowConfirmLogout(false)
    }
  }, [props.isOpened, showConfirmLogout])

  const closeHandler = () => {
    props.close()
    setShowConfirmLogout(false)
  }

  const closeLogoutConfirmation = () => {
    setShowConfirmLogout(false)
  }

  const confirmLogoutHandler = () => {
    setShowConfirmLogout(true)
  }

  const logoutHandler = () => {
    closeHandler()
    props.logout()
  }

  const openRegistrationHandler = () => {
    // if (window.in_native_app && window.platform === 'android') {
    //   window.ReactNativeWebView.postMessage(JSON.stringify({
		// 		type: 'OPEN_REGISTRATION',
		// 	}))

    //   return
    // }

    props.openRegistrationModal()
  }

  return (
    <ReactDragDrawer
      open={props.isOpened}
      onRequestClose={closeHandler}
      direction="left"
      containerElementClass="h-override"
      modalElementClass="h-override fixed top-0 left-0 z-10"
    >
      <div 
        className='w-screen max-w-lg h-override bg-modal flex flex-col justify-start items-start px-4 text-lg'
        style={{
          paddingTop: window.native_app_status_bar_height ?? 16,
          paddingBottom: window.native_app_navigation_bar_height ?? 16
        }}
      >
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row items-center'>
            <img src={LogoImage} alt='Logo' className='w-12 h-12 rounded-lg' />
            <h1 className='ml-2 font-boldb'>Máquina de Contos</h1>
          </div>

          <button
            type="button"
            onClick={closeHandler}
            className={`text-black bg-transparent hover:bg-slate-200 rounded-lg absolute right-4 inline-flex items-center justify-center text-2xl lg:text-xl`}
          >
            <FiX />
          </button>
        </div>

        <hr className='w-full h-0.25 mt-4 mb-2 bg-slate-300' />

        <div className='w-full flex flex-1 flex-col justify-start items-start gap-y-1'>
        {!props.isLoggedIn ? (
            <>
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openLoginModal}>
                <BsBoxArrowInRight className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Entrar</span>
              </button>

              {window.in_native_app ? (
                <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={openRegistrationHandler}>
                  <BsPersonPlus className='w-6 h-6' />
                  <span className='ml-2 mt-0.5 text-lg'>Assinar</span>
                </button>
              ) : null}
            </>
          ) : null}
          
          {!showConfirmLogout ? (
            <>
              {props.isLoggedIn && props.loginProvider === SUBSCRIBER_PROVIDER_NAME ? (
                <>
                  <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openProfileModal}>
                    <BsPerson className='w-6 h-6' />
                    <span className='ml-2 mt-0.5 text-lg'>Perfil</span>
                  </button>
                  <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openPaymentModal}>
                    <BsCash className='w-6 h-6' />
                    <span className='ml-2 mt-0.5 text-lg'>Assinatura</span>
                  </button>
                </>
              ) : null}
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openKnowMore}>
                <BsLightbulb className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Como funciona</span>
              </button>
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openAboutModal}>
                <BsInfoCircle className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Sobre nós</span>
              </button>
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openQuestionsModal}>
                <BsQuestionCircle className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Dúvidas</span>
              </button>
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openContactUsModal}>
                <BsEnvelope className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Fale conosco</span>
              </button>
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openTermsOfUseModal}>
                <BsFileEarmarkText className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Termos de uso</span>
              </button>
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={props.openPrivacyPolicyModal}>
                <BsShieldLock className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Política de Privacidade</span>
              </button>
            </>
          ) : null}

          {props.isLoggedIn ? (
            <div
              className={clsx('w-full relative')}
            >
              {showConfirmLogout ? (
                <div className='w-full text-center'>
                  <p className='text-2xl font-bold mb-2'>Deseja realmente sair?</p>
                  <p>Ao clicar em <b>SIM</b>, você não poderá mais ler os livros, a menos que faça login novamente.</p>

                  <div className='w-full flex flex-col space-y-4 mt-8'>
                    <Button onClick={closeLogoutConfirmation}>Não</Button>

                    <GhostButton onClick={logoutHandler}>Sim</GhostButton>
                  </div>
                </div>
              ) : (
              <button className='flex flex-row justify-center items-center py-2.5' type="button" onMouseEnter={() => { playSong(songsName.TAP) }} onClick={confirmLogoutHandler}>
                <BsBoxArrowRight className='w-6 h-6' />
                <span className='ml-2 mt-0.5 text-lg'>Sair</span>
              </button>
              )}
            </div>
          ) : null}

          {window.in_native_app && window.app_version ? (
            <div className='absolute right-4' style={{ bottom: window.native_app_navigation_bar_height }}>
              <span className='text-sm'>V{window.app_version}</span>
            </div>
          ) : null}
        </div>
      </div>
    </ReactDragDrawer>
  )
}

export default DrawerMenu